export default {
  SET_FILTER: 'SET_FILTER',
  SET_SORT: 'SET_SORT',
  SET_PAGING_MODE: 'SET_PAGING_MODE',
  SET_IS_DATASET_READY: 'SET_IS_DATASET_READY',
  SET_FIXED_FILTER_ITEM: 'SET_FIXED_FILTER_ITEM',
}
